define('lq/events/actions/reportCommand',[
    'lq/events/actions/eventAction',
    'lq',
    'when'
], function (EventAction, lq, when) {
    'use strict';

    var pollDelayInMilliseconds = 1000;
    
    function ReportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ReportCommand, EventAction);

    ReportCommand.typeName = 'ReportCommand';

    ReportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    ReportCommand.prototype.execute = function (continuation) {
        var self = this;
        var piping = this.piping;

        this.piping.dispatcher.dispatchToAbsoluteUrl(
            this.piping.url.prepare(lq.getTenantUrl('Report/'), {}),
                {
                    actionId: this.rootDrop.data.id,
                    commandId: this.eventData.command,
                    globals: piping.parameters.globals.getAll(),
                    locals: piping.parameters.locals.getAll()
                })
            .then(function (response) {
                if (!response.ticketNumber) { // "generate in the background" is probably enabled
                    continuation();
                } else {
                    function isReady() {
                        return $.get({
                            url: lq.getTenantUrl('Report/IsReady'),
                            data: {
                                ticketNumber: response.ticketNumber
                            },
                            cache: false
                        });
                    }

                    function poll(operation) {
                        return when.promise(function (resolve, reject, notify) {
                            setTimeout(function () {
                                resolve(operation()
                                    .always(function (data, textStatus, xhr) {
                                        if (xhr.status === 202) {
                                            return poll(operation);
                                        } else if (xhr.status === 200) {
                                            if (data.isDirty) {
                                                if (self.eventIsEnabled('onExecutionTrailDirty'))
                                                    self.triggerEvent('onExecutionTrailDirty', continuation);
                                                else {
                                                    alert('Could not create report, because the data is dirty.');
                                                    continuation();
                                                }
                                            } else {
                                                if (data.download) {
                                                    var url = data.url
                                                        ? piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), { url: data.url, filename: data.filename, openInBrowser: data.downloadBehaviour !== 'download' })
                                                        : piping.url.prepare(lq.getTenantUrl('Report/Download'), { ticketNumber: response.ticketNumber });
    
                                                    if (data.downloadBehaviour === 'openInCurrentTab' || data.downloadBehaviour === 'download') {
                                                        window.location = url;
                                                    } else {
                                                        window.open(url + '#toolbar=1');
                                                    }
                                                }
    
                                                if (data.entityIdParameter) {
                                                    var targetParameters = data.entityIdParameterIsGlobal
                                                        ? piping.parameters.globals
                                                        : piping.parameters.locals;
                                                    targetParameters.setValue(data.entityIdParameter, data.entityIdValue);
                                                }
    
                                                continuation();
                                            }
                                        }
                                    }));
                            },
                            pollDelayInMilliseconds);
                        });
                    }

                    poll(isReady);
                }
            })
            .catch(function() {
                alert('Something went wrong while creating the report.');
            });
    };
    
    return ReportCommand;
});
